import { Dispatch } from 'react';
import { CoreApi } from '../../../api/api.apiclient';
import { PageRequest } from '../../../api/api.types';
import { DeskGroupFilters, DeskGroupRequest } from '../../../api/core/core.types';
import {
  GET_DESK_GROUP_LIST,
  GET_DESK_GROUP,
  POST_DESK_GROUP,
  DELETE_DESK_GROUP,
  PUT_DESK_GROUP
} from '../types/deskgroup.types';

export const getDeskGroupList = (filters?: DeskGroupFilters, pageRequest?: PageRequest) => async (dispatch: Dispatch<any>): Promise<void> => {
  const response = await CoreApi.DeskGroups.listAllDeskGroups(filters, pageRequest);

  dispatch({
    type: GET_DESK_GROUP_LIST,
    payload: {
      page: response.data
    }
  });

  return Promise.resolve();
};

export const getDeskGroup = (id: number) => async (dispatch: Dispatch<any>) => {
  try {
    const response = await CoreApi.DeskGroups.getOneDeskGroup(id);

    dispatch({
      type: GET_DESK_GROUP,
      payload: {
        selectedDeskGroup: response.data
      }
    });

  } catch (e) {
    dispatch({
      type: GET_DESK_GROUP,
      payload: {
        selectedDeskGroup: null
      }
    });
  }
};

export const addNewDeskGroup = (request: DeskGroupRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.DeskGroups.addNewDeskGroup(request);
  dispatch(getDeskGroupList());

  dispatch({
    type: POST_DESK_GROUP,
    payload: {
      success: true,
      newDeskGroup: response.data
    }
  });
};

export const deleteDeskGroup = (id: number) => async (dispatch: Dispatch<any>) => {
  await CoreApi.DeskGroups.deleteDeskGroup(id);
  dispatch(getDeskGroupList());
  dispatch({
    type: DELETE_DESK_GROUP,
    payload: {
      success: true
    }
  });
};

export const editDeskGroup = (id: number, request: DeskGroupRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.DeskGroups.editDeskGroup(id, request);
  dispatch(getDeskGroupList());

  dispatch({
    type: PUT_DESK_GROUP,
    payload: {
      selectedDeskGroup: response.data
    }
  });
};
